import { TableCell, TableHead, TableRow } from '@one-thd/sui-atomic-components';
import React from 'react';
import { ODTableHeaderData } from './ODTableHeaderData';
// 🚨 Will fix after merge
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export var ODTableHeader = function (_a) {
    var tableHeaderState = _a.tableHeaderState;
    var tableHeaderData = ODTableHeaderData(tableHeaderState);
    var emptyHeaders = [];
    return (React.createElement(TableHead, null,
        React.createElement(TableRow, null,
            React.createElement(React.Fragment, null,
                React.createElement(TableCell, { style: { width: '65px' } }, "\u00A0"), tableHeaderData === null || tableHeaderData === void 0 ? void 0 :
                tableHeaderData.map(function (header, index) {
                    if ((header === null || header === void 0 ? void 0 : header.showHeader) === false) {
                        emptyHeaders.push(header);
                        return null;
                    }
                    return (React.createElement(TableCell, { key: index, align: "left", variant: "head", padding: "none", style: header === null || header === void 0 ? void 0 : header.style }, header === null || header === void 0 ? void 0 : header.title));
                }), emptyHeaders === null || emptyHeaders === void 0 ? void 0 :
                emptyHeaders.map(function (header, key) {
                    return (React.createElement(TableCell, { key: key, align: "left", variant: "head", padding: "none", style: header === null || header === void 0 ? void 0 : header.style },
                        React.createElement("div", null)));
                }),
                React.createElement(TableCell, { style: { width: '50px' } }, "\u00A0")))));
};
